module.exports = __webpack_public_path__ + "img/refresh.9c323498.svg";